'use client'
import React, { useState, useEffect } from 'react'
import LargePropertyCard from '@components/LargePropertyCard'
import SearchMap from '@components/SearchMap'
import MobileSearchMap from '@components/MobileSearchMap'
import MobileMapPropertyCard from '@components/MobileMapPropertyCard'
import { getFilteredProperties2 } from '@services/getFilteredProperties2'

import { useSession } from 'next-auth/react'
import { saleTypes } from '@constants/saleTypes'

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';

const SearchResultCards = ({ searchParams, dictionary, lang = 'en' }) => {

    const { data: session } = useSession()
    let userEmail = null

    // const [currency, setCurrencyType] = useState('thb')
    const [search, setSearch] = useState(searchParams)
    const [page, setPage] = useState(1);
    const [allPages, setAllPages] = useState(1);
    // const [properties, setProperties] = useState([]);
    const [properties, setProperties] = useState([]);
    const [propertyCount, setPropertyCount] = useState(0);
    const [showMap, setShowMap] = useState(false)
    const [coordinates, setCoordinates] = useState([])
    const [hoveredProperty, setHoveredProperty] = useState(null)
    const [activeProperty, setActiveProperty] = useState({})
    const [activePropertyLat, setActivePropertyLat] = useState(13.732772)
    const [activePropertyLng, setActivePropertyLng] = useState(100.5801953)

    if (session !== null) {
        userEmail = session?.user?.email
    }

    const handleMouseEnter = (propertyId) => {
        // console.log(e)
        // console.log('hover ' + propertyId)
        setHoveredProperty(propertyId)
    };
    const handleMouseLeave = () => {
        // console.log('hover end')
        setHoveredProperty(null)
    };

    const handleSlideChange = (swiper) => {
        // Emit your event or perform actions when the active slide changes
        const activeSlideIndex = swiper.activeIndex;
        // console.log(`Active slide index: ${activeSlideIndex}`);
        let activePropertyId = swiper.slides[activeSlideIndex].id
        let activePropertyLat = swiper.slides[activeSlideIndex].dataset.latitude
        let activePropertyLng = swiper.slides[activeSlideIndex].dataset.longitude
        setActiveProperty(activePropertyId)
        setActivePropertyLat(activePropertyLat)
        setActivePropertyLng(activePropertyLng)

        // Emit an event or perform actions here
    };

    const getData = async () => {
        const result = await getFilteredProperties2({
            saleType: searchParams.saleType || saleTypes[lang][0].value,
            bts: searchParams.bts || '',
            district: searchParams.district || '',
            location: searchParams.location || '',
            project: searchParams.project || '',
            category: searchParams.category || '',
            minBedrooms: searchParams.minBedrooms || '',
            maxBedrooms: searchParams.maxBedrooms || '',
            room: searchParams.room || '',
            currency: searchParams.currency || 'thb',
            minprice: searchParams.minprice || '',
            maxprice: searchParams.maxprice || '',
            petfriendly: searchParams.petfriendly || '',
            seaview: searchParams.seaview || '',
            beachfront: searchParams.beachfront || '',
            map: searchParams.map || false,
            sort: searchParams.sort || 'datedesc',
            // limit: searchParams.limit || 10,
            page: page
        },
            userEmail,
            lang
        )

        // setProperties(result.properties)
        if (page > 1) {
            setProperties((prev) => [...prev, ...result.properties])
        } else {
            setProperties(result.properties)
        }
        setAllPages(result.pages)
        setPropertyCount(result.count)
        setCoordinates(result.coordinates)
        if (result.properties.length > 0 && page == 1) {
            setActiveProperty(result.properties[0].id)
            setActivePropertyLat(Number(result.properties[0].latitude))
            setActivePropertyLng(Number(result.properties[0].longitude))
        }
    }

    useEffect(() => {
        setPage(1)
        setProperties([])
        setShowMap(searchParams.map)

        getData()
    }, [searchParams])

    useEffect(() => {
        getData()
    }, [page])

    return (
        <div className='md:w-full 2xl:w-8/12 sm:min-h-[80vh] flex md:flex-row flex-col flex-nowrap md:flex-wrap mx-auto md:px-3 px-0'>
            {showMap ? (
                <div className='w-full relative flex flex-row mx-auto'>
                    <div className='md:flex hidden md:h-[80vh] h-full min-w-[320px] pt-2 overflow-hidden overflow-y-scroll rounded-l-md border-forth border-[1px] border-solid flex-col items-center scrollable' >
                        {properties.map((property, index) => (
                            <div
                                key={property.id}
                                id={property.id}
                                // className='m-2'
                                onMouseEnter={() => (handleMouseEnter(property.id))}
                                onMouseLeave={handleMouseLeave}
                                className='mb-2'
                            >
                                <LargePropertyCard
                                    lang={lang}
                                    dictionary={dictionary.card}
                                    property={property}
                                    isLast={index === properties.length - 1}
                                    // imageWidth={imageWidth}
                                    newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                                />
                            </div>
                        ))}
                    </div>
                    <div className='md:hidden block absolute bottom-0 left-0 right-0 z-[52]'>
                        <div className='sm:hidden block'>
                            <Swiper
                                slidesPerView={1}
                                onSlideChange={handleSlideChange}
                            >
                                {properties.map((property, index) => (
                                    <SwiperSlide
                                        key={property.id}
                                        id={property.id}
                                        data-latitude={Number(property.latitude)}
                                        data-longitude={Number(property.longitude)}
                                    >
                                        <MobileMapPropertyCard
                                            lang={lang}
                                            dictionary={dictionary.card}
                                            property={property}
                                            isLast={index === properties.length - 1}
                                            // imageWidth={imageWidth}
                                            newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>

                    <div className='md:block hidden md:h-[80vh] h-full md:relative absolute w-full border-forth border-[1px] border-solid rounded-r-md overflow-hidden'>
                        <SearchMap coordinates={coordinates} hoveredProperty={hoveredProperty} latitude={searchParams.latitude} longitude={searchParams.longitude} lang={lang} dictionary={dictionary} />
                    </div>
                    <div className='md:hidden block w-full h-full z-[51]'>
                        <MobileSearchMap coordinates={coordinates} hoveredProperty={activeProperty} zoomControl={false} latitude={activePropertyLat} longitude={activePropertyLng} lang={lang} dictionary={dictionary} />
                    </div>
                </div>
            ) : (
                <>
                    {properties.map((property, index) => (
                        <div
                            key={property.id}
                            className='m-2'
                        >
                            <LargePropertyCard className='m-3'
                                lang={lang}
                                dictionary={dictionary.card}
                                property={property}
                                isLast={index === properties.length - 1}
                                // imageWidth={imageWidth}
                                newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                            />
                        </div>
                    ))}
                </>
            )}
        </div>
    )
}

export default SearchResultCards